import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const PROMOTIONS_NAMESPACE_TOKEN = new InjectionToken<string | Observable<string>>(
  '[Promotions]: token for namespace (e.g. accountGroupId)',
);

export interface PromotionsFlyerBranding {
  bgColor?: string;
  textColor?: string;
  logoUrl?: string;
}

export const PROMOTIONS_FLYER_BRANDING_TOKEN = new InjectionToken<Observable<PromotionsFlyerBranding>>(
  '[Promotions]: token for flyer branding (bgColor, textColor, logoUrl)',
);
